export function createValidationError(e) {
  if (e instanceof ValidationError) {
    return e;
  }

  if (e && e.response && e.response.status === 400) {
    return new ValidationError(e.response.data);
  }

  throw e;
}

export class ValidationError {
  constructor(errors = {}) {
    this.errors = errors;
  }
}
